import { render, staticRenderFns } from "./Annotation.vue?vue&type=template&id=4fcd9dd2&"
import script from "./Annotation.vue?vue&type=script&lang=ts&"
export * from "./Annotation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fcd9dd2')) {
      api.createRecord('4fcd9dd2', component.options)
    } else {
      api.reload('4fcd9dd2', component.options)
    }
    module.hot.accept("./Annotation.vue?vue&type=template&id=4fcd9dd2&", function () {
      api.rerender('4fcd9dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/search/form/Annotation.vue"
export default component.exports